import { createClient } from '@supabase/supabase-js';
import { Database } from '../../types/supabase';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const isTestEnv = process.env.NODE_ENV === 'test';

if (!supabaseUrl || !supabaseAnonKey) {
  const message =
    'Supabase env vars missing. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env before starting the app.';
  if (isTestEnv) {
    // Tests mock the supabase client; allow placeholders so unrelated suites can boot.
    // eslint-disable-next-line no-console
    console.warn('[supabase/client]', message);
  } else {
    throw new Error(message);
  }
}

export const supabase = createClient<Database>(
  supabaseUrl ?? 'https://placeholder.supabase.co',
  supabaseAnonKey ?? 'placeholder',
  {
    auth: {
      // Detect the recovery/confirmation token in the URL on load and exchange it
      // for a session. Without this, password-reset links land on /update-password
      // with no session and updateUser() fails.
      detectSessionInUrl: true,
      persistSession: true,
      autoRefreshToken: true,
      flowType: 'pkce',
    },
  },
);
